(function () {
    'use strict';

    angular
        .module('cacmFollowUpModule')
        .directive('cacmFollowUp', directive);

    directive.$inject = ['boxTmplScope', 'boxTmplHtml', 'boxTmplLinkFn', 'historyCtxtService'];

    function directive(boxTmplScope, boxTmplHtml, boxTmplLinkFn, historyCtxtService) {

        var directiveScope = _.clone(boxTmplScope);
        directiveScope.getDownloadAttachmentUrl = '&';
        directiveScope.canEdit = '&';

        return {
            scope: directiveScope,
            template: boxTmplHtml,
            controller: ['$rootScope', '$scope', '$controller',
                function ($rootScope, $scope, $controller) {
                    // Box Template
                    $scope.baseTemplatePath = '/app/shared/cacm/followup/cacmFollowUp.[Template].tpl.html';
                    // Permissions default values
                    $scope.boxFeatureRole = $scope.boxFeatureRole || 'CACMControlManagement';
                    $scope.boxPermissionKey = $scope.boxPermissionKey || 'EventFollowUp';
                    var paramCanEdit = $scope.canEdit();
                    $scope.canEdit = _.isBoolean(paramCanEdit) ? paramCanEdit : true;

                    $controller('BoxTmplController', { $scope: $scope });

                    $scope.currentDraft = {};

                    $scope.goToParentEvent = function() {
                        historyCtxtService.goToState('cacmEditEvent',
                            { CACMEventID: $scope.boxContext.Event.ParentID },
                            historyCtxtService.getCtxName()
                        );
                    };

                    $scope.$watch('boxModel', function () {
                        if ($scope.boxModel && $scope.boxModel.followUps) {
                            var currentDraftIndex = _.findIndex($scope.boxModel.followUps, {IsSubmitted: false, IsOwnFollowUp: true, CACMEventID: $scope.boxContext.Event.CACMEventID});
                            if (currentDraftIndex > -1) {
                                _.merge($scope.currentDraft, $scope.boxModel.followUps.splice(currentDraftIndex, 1)[0]);
                            }
                        }
                    }, true);
                }],
            link: function (scope, elem, attrs) {
                boxTmplLinkFn(scope, elem, attrs);
            }
        }
    }
})();
